var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmallLeaves = function SvgSmallLeaves(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433.096,
    height: 509.535,
    viewBox: "0 0 433.096 509.535",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SmallLeaves",
    transform: "matrix(0.809, -0.588, 0.588, 0.809, -240.817, 221.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M836.48,139.227c-16.55,2.9-31.636-4.29-31.636-4.29s11.748-11.883,28.3-14.78,31.636,4.29,31.636,4.29S853.03,136.33,836.48,139.227Z",
    transform: "translate(-404.74 -53.936)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M822.773,639.8c-16.155-4.618-26.59-17.669-26.59-17.669s15.757-5.563,31.911-.945,26.59,17.669,26.59,17.669S838.928,644.417,822.773,639.8Z",
    transform: "translate(-401.747 -226.687)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M1015.053,411.361c-16.191,4.49-31.9-1.2-31.9-1.2s10.539-12.968,26.729-17.458,31.9,1.2,31.9,1.2S1031.243,406.871,1015.053,411.361Z",
    transform: "translate(-466.36 -147.765)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M1000.753,328.649c-16.191,4.49-31.9-1.2-31.9-1.2s10.539-12.968,26.729-17.457,31.9,1.2,31.9,1.2S1016.943,324.159,1000.753,328.649Z",
    transform: "translate(-461.418 -119.182)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M682.094,51.408c-9.723,13.7-25.5,19.209-25.5,19.209s-.012-16.71,9.711-30.413S691.805,21,691.805,21,691.817,37.705,682.094,51.408Z",
    transform: "translate(-353.508 -19.905)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M637.47,248.182c-16.191,4.49-31.9-1.2-31.9-1.2s10.539-12.968,26.729-17.457,31.9,1.2,31.9,1.2S653.661,243.692,637.47,248.182Z",
    transform: "translate(-335.874 -91.373)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M270.224,270.767c-9.118-14.113-8.379-30.806-8.379-30.806s15.522,6.188,24.64,20.3,8.379,30.806,8.379,30.806S279.342,284.879,270.224,270.767Z",
    transform: "translate(-51.764 -95.576)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M457.6,328.649c-16.191,4.49-31.9-1.2-31.9-1.2s10.539-12.968,26.73-17.457,31.9,1.2,31.9,1.2S473.794,324.159,457.6,328.649Z",
    transform: "translate(-108.394 -119.182)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M279.623,638.615c-16.155-4.619-26.59-17.669-26.59-17.669s15.757-5.563,31.911-.945,26.59,17.67,26.59,17.67S295.778,643.234,279.623,638.615Z",
    transform: "translate(-48.723 -226.278)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M458.444,492.791c-9.723,13.7-25.5,19.209-25.5,19.209s-.012-16.71,9.711-30.413,25.5-19.209,25.5-19.209S468.167,479.089,458.444,492.791Z",
    transform: "translate(-110.898 -172.44)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M1000.364,492.549c-9.723,13.7-25.5,19.209-25.5,19.209s-.012-16.71,9.711-30.413,25.5-19.209,25.5-19.209S1010.082,478.847,1000.364,492.549Z",
    transform: "translate(-463.496 -172.356)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M471.9,411.361c-16.191,4.49-31.9-1.2-31.9-1.2s10.539-12.968,26.73-17.458,31.9,1.2,31.9,1.2S488.092,406.871,471.9,411.361Z",
    transform: "translate(-113.335 -147.765)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M367.487,648.185l-1.5-.366a296.673,296.673,0,0,0,6.449-69.058c-.859-35.205-9.089-84.323-43.413-118.387-26.55-26.349-36.742-50.806-30.292-72.691,7.353-24.95,35.348-41.909,57.538-51.742A266.964,266.964,0,0,1,402.97,320.45l.321,1.516a265.323,265.323,0,0,0-46.426,15.4c-21.881,9.7-49.472,26.378-56.655,50.754-6.276,21.3,3.783,45.236,29.9,71.153,15.33,15.214,26.833,34.625,34.189,57.693,5.876,18.428,9.134,39.219,9.682,61.794A298.231,298.231,0,0,1,367.487,648.185Z",
    transform: "translate(-63.865 -123.392)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M398.122,584.248c-.018-.441-1.428-44.471,33.316-73.038l.984,1.2c-34.155,28.084-32.77,71.344-32.753,71.778Z",
    transform: "translate(-98.859 -189.315)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M374.544,693.067c-.273-.444-27.648-44.51-58.778-55.9l.532-1.455c31.637,11.575,59.289,56.094,59.565,56.543Z",
    transform: "translate(-70.403 -232.342)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M392.661,407.086c-36.865,0-69.708-19.223-70.093-19.451l.791-1.332c.447.265,45.171,26.43,88.5,17.307l.319,1.516A94.728,94.728,0,0,1,392.661,407.086Z",
    transform: "translate(-72.753 -146.15)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M361.374,330.417a99.512,99.512,0,0,1-22.686-2.622c-16.6-4.109-26.118-12.65-27.538-24.7l1.538-.181c3.251,27.59,50.1,25.95,50.567,25.929l.065,1.547C363.29,330.389,362.59,330.417,361.374,330.417Z",
    transform: "translate(-68.807 -117.331)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M424.662,511.331v-1.09c0-.169.1-17.116,9.854-30.862s25.716-19.436,25.876-19.492l1.029-.359v1.09c0,.169-.1,17.116-9.854,30.861s-25.716,19.436-25.876,19.492Zm35.171-49.564c-3.683,1.512-16.039,7.214-24.054,18.509s-9.32,24.843-9.528,28.817c3.683-1.512,16.039-7.214,24.054-18.509S459.624,465.741,459.833,461.768Z",
    transform: "translate(-108.035 -171.455)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M621.772,144.05c-.018-.442-1.428-44.472,33.316-73.039l.984,1.2c-34.155,28.083-32.77,71.344-32.753,71.778Z",
    transform: "translate(-341.469 -37.19)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M648.312,71.131v-1.09c0-.169.1-17.116,9.854-30.861s25.716-19.436,25.876-19.492l1.029-.359v1.09c0,.169-.1,17.116-9.854,30.861h0c-9.754,13.745-25.716,19.436-25.876,19.492Zm35.171-49.563c-3.683,1.512-16.039,7.214-24.054,18.509s-9.32,24.843-9.528,28.816c3.683-1.512,16.039-7.214,24.054-18.509s9.32-24.843,9.529-28.816Z",
    transform: "translate(-350.645 -19.33)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M725.928,164.479l-1.145-1.043c.3-.327,30.284-32.609,75.062-28.465l-.142,1.542C755.7,132.447,726.221,164.157,725.928,164.479Z",
    transform: "translate(-377.073 -59.166)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M827.723,134.359a62.142,62.142,0,0,1-23.907-5.045l-.984-.469.766-.775c.119-.121,12.114-12.093,28.715-15s31.95,4.281,32.1,4.354l.984.468-.766.775c-.119.121-12.113,12.093-28.714,15A47.573,47.573,0,0,1,827.723,134.359Zm-22.187-5.988c3.68,1.517,16.474,6.159,30.115,3.771s24.1-11.1,27.045-13.775c-3.681-1.517-16.474-6.156-30.115-3.77-13.657,2.391-24.1,11.1-27.045,13.775Z",
    transform: "translate(-404.045 -51.486)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M920.844,266.322c-15.534-6.4-24.437-20.544-24.437-20.544s16.282-3.758,31.816,2.645,24.437,20.544,24.437,20.544S936.378,272.725,920.844,266.322Z",
    transform: "translate(-436.383 -97.208)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M940.453,265.686a54.4,54.4,0,0,1-20.556-3.779c-15.582-6.423-24.707-20.7-24.8-20.847l-.58-.922,1.062-.245c.165-.038,16.7-3.739,32.284,2.684s24.707,20.7,24.8,20.847l.58.922-1.062.245A58.5,58.5,0,0,1,940.453,265.686Zm-43.4-24.5c2.3,3.251,10.627,14.014,23.43,19.292,12.818,5.284,26.3,3.512,30.219,2.825-2.3-3.25-10.627-14.014-23.431-19.292S900.979,240.5,897.057,241.183Z",
    transform: "translate(-435.731 -95.174)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M455.541,410.016a62.207,62.207,0,0,1-18.961-2.958l-1.015-.368.687-.846c.107-.132,10.882-13.211,27.123-17.715s32.214,1.159,32.373,1.216l1.025.371-.687.846c-.107.132-10.882,13.212-27.123,17.715A50.322,50.322,0,0,1,455.541,410.016Zm-17.332-4.06c3.81,1.152,16.991,4.53,30.34.828s22.91-13.385,25.58-16.335c-3.811-1.153-16.993-4.531-30.34-.828s-22.91,13.385-25.58,16.335Z",
    transform: "translate(-111.803 -146.18)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M623.574,244.349a62.2,62.2,0,0,1-18.961-2.958l-1.015-.368.687-.846c.107-.132,10.882-13.212,27.123-17.715s32.214,1.159,32.373,1.216l1.025.371-.687.846c-.107.132-10.882,13.212-27.123,17.715A50.323,50.323,0,0,1,623.574,244.349Zm-17.332-4.06c3.81,1.152,16.992,4.529,30.34.828s22.91-13.385,25.58-16.335c-3.811-1.153-16.992-4.531-30.34-.828s-22.91,13.385-25.58,16.335Z",
    transform: "translate(-335.193 -88.928)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M443.707,324.816a62.207,62.207,0,0,1-18.961-2.958l-1.015-.368.687-.846c.107-.132,10.882-13.211,27.123-17.715s32.214,1.159,32.373,1.216l1.025.371-.687.846c-.107.132-10.882,13.212-27.123,17.715a50.322,50.322,0,0,1-13.422,1.738Zm-17.332-4.059c3.81,1.152,16.992,4.529,30.34.828s22.91-13.385,25.58-16.335c-3.811-1.153-16.992-4.531-30.34-.828s-22.909,13.385-25.58,16.335Z",
    transform: "translate(-107.714 -116.736)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M292.6,636.074a50.591,50.591,0,0,1-13.871-1.847c-16.2-4.633-26.876-17.8-26.982-17.931l-.68-.851,1.027-.363c.16-.055,16.178-5.589,32.382-.959s26.876,17.8,26.982,17.931l.68.851-1.027.363A62.137,62.137,0,0,1,292.6,636.074Zm-13.446-3.337c13.316,3.809,26.524.536,30.345-.587-2.65-2.972-12.134-12.731-25.449-16.537s-26.524-.535-30.345.587c2.65,2.972,12.133,12.732,25.449,16.538Z",
    transform: "translate(-48.045 -224.243)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M299.916,289.23l-1.012-.4c-.158-.063-15.858-6.443-25-20.6h0c-9.146-14.156-8.51-31.091-8.5-31.261l.048-1.089,1.012.4c.158.063,15.858,6.443,25,20.6s8.51,31.091,8.5,31.261ZM275.2,267.387c7.516,11.632,19.611,17.867,23.226,19.538-.038-3.982-.75-17.571-8.265-29.2s-19.611-17.867-23.226-19.538C266.974,242.165,267.686,255.755,275.2,267.387Z",
    transform: "translate(-52.992 -94.165)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M941.272,584.248c-.018-.441-1.428-44.471,33.316-73.038l.983,1.2c-34.154,28.083-32.77,71.344-32.752,71.778Z",
    transform: "translate(-451.884 -189.315)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M924.693,689.067c-.273-.444-27.648-44.51-58.778-55.9l.532-1.455c31.637,11.575,59.289,56.094,59.565,56.543Z",
    transform: "translate(-425.846 -230.959)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M935.811,407.086c-36.866,0-69.709-19.223-70.093-19.451l.791-1.332c.446.266,45.172,26.428,88.5,17.307l.319,1.516A94.732,94.732,0,0,1,935.811,407.086Z",
    transform: "translate(-425.778 -146.15)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M904.524,330.417a99.521,99.521,0,0,1-22.687-2.622c-16.6-4.109-26.118-12.65-27.538-24.7l1.538-.181c3.25,27.579,50.1,25.948,50.567,25.929l.065,1.547C906.441,330.389,905.74,330.417,904.524,330.417Z",
    transform: "translate(-421.831 -117.331)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M967.813,511.331v-1.09c0-.169.1-17.116,9.854-30.862s25.716-19.436,25.876-19.492l1.029-.359v1.09c0,.169-.1,17.116-9.854,30.861h0c-9.754,13.745-25.716,19.436-25.876,19.492Zm35.166-49.564c-3.683,1.512-16.038,7.214-24.054,18.509s-9.319,24.843-9.528,28.817c3.683-1.512,16.038-7.214,24.054-18.509S1002.776,465.741,1002.979,461.768Z",
    transform: "translate(-461.059 -171.455)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M998.691,410.016a62.216,62.216,0,0,1-18.962-2.958l-1.015-.368.687-.846c.107-.132,10.883-13.211,27.124-17.715s32.215,1.159,32.374,1.216l1.024.371-.687.846c-.107.132-10.883,13.212-27.124,17.715h0A50.323,50.323,0,0,1,998.691,410.016Zm-17.331-4.059c3.812,1.153,16.993,4.53,30.338.828h0c13.345-3.7,22.906-13.384,25.58-16.335-3.812-1.152-16.992-4.529-30.338-.828s-22.907,13.383-25.58,16.335Z",
    transform: "translate(-464.827 -146.18)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M160.4,456.5c16.445,3.445,27.792,15.711,27.792,15.711s-15.316,6.682-31.761,3.237-27.792-15.711-27.792-15.711S143.957,453.056,160.4,456.5Z",
    transform: "translate(-5.736 -170.068)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M217.939,483.94c32.751,16.925,53.1,49.081,53.339,49.46l-1.314.82c-.274-.441-28-44.217-70.676-56.006l.412-1.493A94.722,94.722,0,0,1,217.939,483.94Z",
    transform: "translate(-30.15 -177.396)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M173.208,464.134a62.2,62.2,0,0,1,15.48,11.326l.739.8-1,.436c-.156.068-15.734,6.74-32.23,3.285s-28.087-15.82-28.2-15.944l-.739-.8,1-.436c.156-.068,15.734-6.74,32.23-3.285h0a50.327,50.327,0,0,1,12.722,4.618ZM186.74,475.7c-2.857-2.774-13.017-11.826-26.572-14.664h0c-13.555-2.84-26.494,1.373-30.224,2.768,2.857,2.773,13.016,11.825,26.572,14.664S183.01,477.092,186.74,475.7Z",
    transform: "translate(-5.257 -171.108)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M986.857,324.816a62.213,62.213,0,0,1-18.962-2.958l-1.015-.368.687-.846c.107-.132,10.883-13.211,27.124-17.715s32.215,1.159,32.374,1.216l1.024.371-.687.846c-.107.132-10.883,13.212-27.124,17.715h0A50.324,50.324,0,0,1,986.857,324.816Zm-17.331-4.059c3.812,1.153,16.994,4.53,30.338.828h0c13.345-3.7,22.907-13.384,25.58-16.335-3.812-1.153-16.992-4.529-30.338-.828s-22.906,13.383-25.58,16.335Z",
    transform: "translate(-460.738 -116.736)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M835.753,636.074a50.586,50.586,0,0,1-13.871-1.847c-16.205-4.633-26.876-17.8-26.983-17.931l-.68-.851,1.027-.363c.16-.055,16.177-5.589,32.382-.959s26.877,17.8,26.983,17.931l.681.851-1.028.363a62.135,62.135,0,0,1-18.511,2.806Zm-38.9-19.875c2.65,2.971,12.133,12.732,25.449,16.538h0c13.315,3.809,26.524.536,30.345-.587-2.651-2.972-12.134-12.731-25.449-16.537-13.33-3.812-26.528-.537-30.344.586Z",
    transform: "translate(-401.069 -224.243)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M811.008,268.4c-9.118-14.113-8.379-30.806-8.379-30.806s15.522,6.188,24.64,20.3,8.379,30.806,8.379,30.806S820.126,282.513,811.008,268.4Z",
    transform: "translate(-403.97 -94.758)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M843.066,289.23l-1.012-.4c-.157-.063-15.858-6.443-25-20.6h0c-9.146-14.156-8.51-31.091-8.5-31.261l.048-1.089,1.012.4c.158.063,15.858,6.443,25,20.6s8.51,31.091,8.5,31.261ZM818.35,267.387c7.524,11.645,19.613,17.871,23.225,19.539-.037-3.981-.749-17.571-8.265-29.2s-19.611-17.867-23.225-19.538c.038,3.982.75,17.571,8.265,29.2Z",
    transform: "translate(-406.016 -94.165)",
    fill: "#c1e9e5"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmallLeaves, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SmallLeaves.63819750.svg";
export { ForwardRef as ReactComponent };